/**
 * Function parse the HTML tag embedded text into regular text.
 */
const parseTextFromHtml = (text) => {
  // Parsing
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  let parsedText = doc.body.textContent;
  // Remove extra white spaces;
  parsedText = parsedText.replace(/\s+/g, ' ').replace(/\s+,/g, ',').replace(/\s+\./g, '.').trim();

  return parsedText;
};

export default parseTextFromHtml;
